import React from 'react'

const NoRecordFound = () => {
  return (
    <div className="noRecord">
    <p>No records found!</p>
  </div>
  )
}

export default NoRecordFound
